// =============================================================================
// SETTING PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'settings',
  component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePaymentGateway" */ '@/mobile/views/admin/settings/index.vue') : import(/* webpackChunkName: "desktopPaymentGateway" */ '@/desktop/views/admin/settings/index.vue') },
  children: [
    {
      path: '',
      name: 'Settings',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSettings" */ '@/mobile/views/admin/settings/setting/settingMenu.vue') : import(/* webpackChunkName: "desktopSettings" */ '@/desktop/views/admin/settings/setting/settingMenu.vue') },
      meta: {
        pageTitle: 'تنظیمات',
        pageTitleI18n: 'pages.setting.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'company-info',
      name: 'companyInfoSetting',
      component: () => import(/* webpackChunkName: "companyInfoSetting" */ '../../views/admin/companyInfo/edit/./editCompanyInfo'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.companyInfo.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'backup',
      name: 'backup',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileBackup" */ '@/mobile/views/admin/settings/backup/backup.vue') : import(/* webpackChunkName: "desktopBackup" */ '@/desktop/views/admin/settings/backup/backup.vue') },
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.backup.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'opening-balance',
      name: 'openingBalance',
      component: () => import(/* webpackChunkName: "openingBalance" */ '../../views/admin/settings/openingBalance/index.vue'),
      meta: {
        permission: 'opening.access',
        pageTitle: '',
        pageTitleI18n: 'pages.setting.openingBalance.title',
        hideContentNavbar: true,
        layoutStatus: 'profile'
        // rule: 'editor'
      }
    },
    {
      path: 'purchase',
      name: 'purchaseSetting',
      component: () => import(/* webpackChunkName: "purchaseSetting" */ '../../views/admin/settings/purchase/PurchaseSettings.vue'),
      meta: {
        pageTitle: 'تنظیمات خرید',
        pageTitleI18n: 'pages.setting.purchase.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'sale',
      name: 'saleSetting',
      component: () => import(/* webpackChunkName: "saleSetting" */ '../../views/admin/settings/sale/SaleSettings.vue'),
      meta: {
        pageTitle: 'تنظیمات فروش',
        pageTitleI18n: 'pages.setting.sale.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'languages',
      name: 'languagesSetting',
      component: () => import(/* webpackChunkName: "languagesSetting" */ '../../views/admin/settings/locale/LocaleSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.Locale.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'users',
      name: 'usersSetting',
      component: () => import(/* webpackChunkName: "usersSetting" */ '../../views/admin/settings/users/usersSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.users.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'security',
      name: 'securitySetting',
      component: () => import(/* webpackChunkName: "securitySetting" */ '../../views/admin/settings/security/securitySetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.security.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'customizing',
      name: 'customizeSetting',
      component: () => import(/* webpackChunkName: "customizeSetting" */ '../../views/admin/settings/customize/customizeSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.customize.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'financial',
      name: 'financialSetting',
      component: () => import(/* webpackChunkName: "financialSetting" */ '../../views/admin/settings/financial/FinancialSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.financial.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'product',
      name: 'productSetting',
      component: () => import(/* webpackChunkName: "productSetting" */ '../../views/admin/settings/product/ProductSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.product.title',
        // permission: 'addons.advanced_products',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'tax',
      name: 'taxSetting',
      component: () => import(/* webpackChunkName: "taxSetting" */ '../../views/admin/settings/tax/TaxSetting.vue'),
      meta: {
        pageTitle: '',
        pageTitleI18n: 'pages.setting.tax.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'store',
      name: 'storeSetting',
      component: () => import(/* webpackChunkName: "storeSetting" */ '../../views/admin/settings/store/StoreSettings.vue'),
      meta: {
        pageTitle: 'تنظیمات انبار',
        pageTitleI18n: 'pages.setting.warehouse.title',
        permission: 'setting.show',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'financial-year',
      name: 'financialYearSetting',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileFinancialYearSetting" */ '@/mobile/views/admin/settings/financialYear/list/financialYearList.vue') : import(/* webpackChunkName: "desktopFinancialYearSetting" */ '@/desktop/views/admin/settings/financialYear/list/financialYearList.vue') },
      meta: {
        permission: 'financial_year.show',
        pageTitle: 'تنظیمات سال مالی',
        pageTitleI18n: 'pages.setting.financialYear.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'shipping',
      name: 'shippingSetting',
      component: () => import(/* webpackChunkName: "shippingSetting" */ '../../views/admin/settings/shipping/ShippingSetting.vue'),
      meta: {
        permission: 'setting.show',
        pageTitle: 'تنظیمات حمل و نقل',
        pageTitleI18n: 'pages.setting.shipping.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'print',
      name: 'printSetting',
      component: () => import(/* webpackChunkName: "shippingSetting" */ '../../views/admin/settings/print/PrintSetting.vue'),
      meta: {
        permission: 'setting.show',
        pageTitle: 'تنظیمات پرینت',
        pageTitleI18n: 'pages.setting.print.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'message',
      name: 'messageSetting',
      component: () => import(/* webpackChunkName: "messageSetting" */ '../../views/admin/settings/message/messageSetting.vue'),
      meta: {
        permission: 'setting.show',
        pageTitle: 'تنظیمات پیامک',
        pageTitleI18n: 'pages.setting.message.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'report',
      name: 'reportSetting',
      component: () => import(/* webpackChunkName: "reportSetting" */ '../../views/admin/settings/report/reportSettings.vue'),
      meta: {
        permission: 'setting.show',
        pageTitle: 'تنظیمات گزارش',
        pageTitleI18n: 'pages.setting.report.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'advanced',
      name: 'advancedSetting',
      component: () => import(/* webpackChunkName: "advancedSetting" */ '../../views/admin/settings/advanced/advancedSetting.vue'),
      meta: {
        pageTitle: 'تنظیمات پیشرفته',
        pageTitleI18n: '',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    },
    {
      path: 'reset',
      name: 'resetSetting',
      component: () => import(/* webpackChunkName: "resetSetting" */ '../../views/admin/settings/reset/ResetSetting.vue'),
      meta: {
        permission: 'setting.reset_application',
        pageTitle: 'تنظیمات ریست',
        pageTitleI18n: 'pages.setting.reset.title',
        layoutStatus: 'profile'
      // rule: 'editor'
      }
    }
  ]
}
